import {observer} from 'mobx-react';
import React from 'react';
import {transaction} from 'mobx';

import Store, {DiagramMode, tKeyDiagramMode} from '../../stores/store';
import FFDropdownList from '../FFDropdownList';
import {TProvider} from '../../i18n/i18n';

interface DiagramModeChangerProps {
    store: Store;
}

@observer
export class DiagramModeChanger extends React.Component<DiagramModeChangerProps, {}> {
    private diagramModeChanged = (diagramMode: DiagramMode) => {
        const {store} = this.props;
        transaction(() => {
            store.setDiagramMode(diagramMode);
            if (diagramMode !== DiagramMode.None) {
                store.lineDiagramStore.reloadDataFromBackend();
            }
        });
    };

    public render() {
        const {store} = this.props;
        return (
            <TProvider>
                {(t) => {
                    const listItems = Object.values(DiagramMode).map((mode) => ({
                        value: mode,
                        text: t(tKeyDiagramMode(mode)),
                    }));
                    return <FFDropdownList listItems={listItems} selectedValue={store.diagramMode} selectedValueChanged={this.diagramModeChanged} />;
                }}
            </TProvider>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/ExplorerParamsBar/DiagramModeChanger.tsx